"use client"

import { Search } from "lucide-react"
import { useState, useEffect, useRef } from "react"
import { createPortal } from "react-dom"
import SearchOverlay from "@modules/layout/components/search-overlay"

/**
 * Search bar — clicking opens full-screen search overlay panel.
 * The overlay is portalled to document.body so that the translateX transform
 * on the absolutely-centred search container does not confine fixed children.
 */
const SearchBar = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  return (
    <>
      <button
        type="button"
        onClick={() => setIsOpen(true)}
        className="relative flex items-center bg-white border border-gray-200 rounded-full py-2.5 pl-10 pr-5 w-full cursor-text hover:border-gray-300 transition-colors"
        aria-label="Open search"
      >
        <Search className="absolute left-3.5 w-4 h-4 text-gray-500 flex-shrink-0" />
        <span className="text-sm text-gray-800">Search for club, country, player</span>
      </button>

      {mounted && isOpen &&
        createPortal(
          <SearchOverlay onClose={() => setIsOpen(false)} />,
          document.body
        )
      }
    </>
  )
}

export default SearchBar
